import { useState } from 'react';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import styles from './StudentBulkAdd.module.css';
import {
  STUDENT_BULK_ADD,
  STUDENT_BULK_ADD_DESC,
  REQUEST_ACTION,
  STATUS_REVIEW,
  STATUS_REQUEST,
  STATUS_COMPLETE,
} from '../../../constants';

const STATUS_TEXT: { [key: string]: string } = {
  review: STATUS_REVIEW,
  request: STATUS_REQUEST,
  complete: STATUS_COMPLETE,
};

const PAST_REQUESTS = [
  {
    id: 1,
    date: '2025.02.03 14:30',
    title: '학생 일괄 추가해주세요.',
    status: 'review', // review, request, complete
    content: '학생 일괄 추가해주세요.',
    response: null,
  },
  {
    id: 2,
    date: '2025.02.03 14:30',
    title: '학생 일괄 추가해주세요.',
    status: 'request',
    content: '학생 일괄 추가해주세요.',
    response: `안녕하세요.
Selpub Cloud 입니다.
내용 보완이 필요합니다.
업로드 하였던 양식 파일을 수정하여 재 요청해 주세요.`,
  },
  {
    id: 3,
    date: '2025.02.03 14:30',
    title: '학생 일괄 추가해주세요.',
    status: 'complete',
    content: '학생 일괄 추가해주세요.',
    response: `안녕하세요.
Selpub Cloud 입니다.
내용 보완이 필요합니다.
업로드 하였던 양식 파일을 수정하여 재 요청해 주세요.`,
  },
];

export default function StudentBulkAdd() {
  const cx = classNames.bind(styles);
  const [activeItems, setActiveItems] = useState<number[]>([]);

  const toggleItem = (id: number) => {
    setActiveItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <>
      <div className={cx('bulk_add_header')}>
        <h2 className={cx('title')}>{STUDENT_BULK_ADD}</h2>
        <div className={cx('desc_area')}>
          <p className={cx('desc')}>{STUDENT_BULK_ADD_DESC}</p>
          <Link to="request" className={cx('btn', 'b_t', 'request')}>
            {REQUEST_ACTION}
          </Link>
        </div>
      </div>

      <div className={cx('bulk_add_body')}>
        <ul className={cx('past_request_list')}>
          {PAST_REQUESTS.map(
            ({ id, date, title, status, content, response }) => (
              <li
                key={id}
                className={cx('past_request_item', {
                  active: activeItems.includes(id),
                })}
              >
                <div
                  className={cx('past_request_header')}
                  onClick={() => toggleItem(id)}
                  role="button"
                >
                  <div className={cx('past_request_content')}>
                    <div className={cx('date')}>{date}</div>
                    <div className={cx('title')}>{title}</div>
                  </div>
                  <div className={cx('past_request_actions')}>
                    <div className={cx('status', `status_${status}`)}>
                      {STATUS_TEXT[status]}
                    </div>
                    <button type="button" className={cx('btn', 'view_detail')}>
                      <i className={cx('svg_i')}></i>
                      <span className={cx('blind')}>상세보기</span>
                    </button>
                  </div>
                </div>
                <div className={cx('past_request_content_area')}>
                  <div className={cx('content_input')}>
                    <div className={cx('input_text')}>{content}</div>
                  </div>
                  {response && (
                    <div className={cx('past_request_response')}>
                      <div className={cx('response_text')}>{response}</div>
                    </div>
                  )}
                </div>
              </li>
            )
          )}
        </ul>
      </div>
    </>
  );
}
